<template>
  <div class="login-wrapper">
    <b-form class="login-card" @submit.prevent="tryToLogIn">

      <!-- HEADER : ARROW + TITLE -->
      <div class="login-header">
        <div
          class="close-btn"
          role="button"
          aria-label="Retour"
          @click="$emit('close')"
        >
          <i class="fas fa-arrow-left"></i>
        </div>

        <h1 class="login-title text-primary">Connexion</h1>
      </div>


      <b-form-input
        v-model="email"
        type="email"
        class="login-input"
        placeholder="E-Mail"
        required
      />

      <b-form-input
        v-model="password"
        type="password"
        class="login-input"
        placeholder="Mot de passe"
        required
      />

      <b-button type="submit" variant="success" class="login-btn mt-4" block>
        Se connecter
      </b-button>

      <!-- BOTTOM : TEXT + ICON -->
      <div class="bottom-back text-right mr-2 mt-3" @click.prevent="$emit('close')">
        <i class="fas fa-arrow-left mr-1" style="cursor: pointer;"></i>
        <span class="ml-1 font-weight-bold" style="cursor: pointer;">
          Revenir à l’accueil
        </span>

      </div>

    </b-form>
  </div>
</template>


<script>
import Vue from 'vue'
import { authMethods } from "@/state/helpers";

export default {
  name: 'LoginForm',
  emits: ['submit', 'close'],
  data() {
    return {
      email: "",
      password: "",
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,

    }
  },
  methods: {
       
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.tryingToLogIn = true;
      this.isAuthError = false;
      // Reset the authError if it existed.
      this.authError = null;
      return (
        this.logIn({
          email: this.email,
          password: this.password
        })
          // eslint-disable-next-line no-unused-vars
          .then(token => {

            
            
            this.tryingToLogIn = false;
            this.isAuthError = false;
            const redirectFrom = this.$route.query.redirectFrom;

            // Redirect to the originally requested page, or to the home page
             if (!redirectFrom || redirectFrom === "/logout") {
              this.$router.push({ name: "home" });
            } else {
              this.$router.push(
                this.$route.query.redirectFrom || { name: "home" }
            );
            }
          })
          .catch(error => {

            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;

            Vue.prototype.$snotify.error(this.authError);
          })
      );
    },


  }
}
</script>

<style scoped>

.login-wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: radial-gradient(circle at center, #ffffff 0%, #f2f5f9 100%);
}


.login-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  padding: 40px 30px;
  background: transparent;
  text-align: center;
}


.login-input {
  height: 55px;
  border-radius: 10px;
  border: 1.5px solid #1f3a56;
  font-size: 16px;
  margin-bottom: 20px;
  padding-left: 15px;
}

.login-input::placeholder {
  color: #6c7a89;
}

.login-btn {
  height: 55px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  border: none;
  margin-top: 10px;
}

</style>



<style>
.login-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
}

.close-btn {
  position: absolute;
  left: 0;
  font-size: 22px;
  cursor: pointer;
  color: #1f3554;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.close-btn:hover {
  transform: translateX(-4px);
  opacity: 0.8;
}

.login-title {
  font-size: 38px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}


</style>
